
import React, { memo } from 'react';

const TrustedBySection: React.FC = memo(() => {
    return (
        <section className="py-12 border-y border-white/5" aria-label="Trusted By">
            <div className="container mx-auto px-6 lg:px-8 text-center">
                <p className="text-sm font-medium text-zinc-500 uppercase tracking-widest mb-8">Trusted by leading dental practices worldwide</p>
                <div className="flex flex-wrap justify-center gap-12 opacity-40 hover:opacity-100 transition-opacity duration-500">
                    {/* Placeholder Logos - In a real app, these would be SVGs */}
                    {['DentalCare', 'SmileStudio', 'OrthoPro', 'EliteDental', 'BrightSmile'].map((name) => (
                        <div key={name} className="text-xl font-bold font-serif text-zinc-300 select-none">{name}</div>
                    ))}
                </div>
            </div>
        </section>
    );
});

export default TrustedBySection;
